import { Link } from "react-router-dom";
import { ArrowSquareOut } from "@phosphor-icons/react";
import { fmt, fmtInt, brDate } from "./util";

export default function ProdutividadeEquipes({ produtividade, filtros }) {
  const linkEquipe = (p) => {
    const q = new URLSearchParams({ equipe_id: p.equipe_id, inicio: filtros.inicio, fim: filtros.fim, categoria: p.categoria });
    if ((filtros.contrato_ids || []).length === 1) q.set("contrato_id", filtros.contrato_ids[0]);
    return `/apontamentos?${q.toString()}`;
  };
  return (
    <div className="pcp-card" style={{ padding: 20 }} data-testid="produtividade-equipes">
      <div style={{ marginBottom: 12 }}>
        <div className="overline">Equipes</div>
        <h2 className="font-display font-bold text-lg mt-1">Produtividade por equipe</h2>
        <div style={{ fontSize: "0.75rem", color: "#71717A", marginTop: 2 }}>
          {brDate(filtros.inicio)} – {brDate(filtros.fim)} · média diária = total ÷ dias distintos com produção da atividade · uma linha por atividade e unidade
        </div>
      </div>
      {produtividade.length === 0 ? (
        <div className="dash-vazio" data-testid="produtividade-vazio">Sem produção registrada no período</div>
      ) : (
        <div className="dash-table-wrap">
          <table className="pcp-table dash-table-prod" data-testid="produtividade-tabela">
            <thead>
              <tr><th>Equipe</th><th>Atividade</th><th>Un.</th><th style={{ textAlign: "right" }}>Dias c/ produção</th><th style={{ textAlign: "right" }}>Total</th><th style={{ textAlign: "right" }}>Média diária</th><th /></tr>
            </thead>
            <tbody>
              {produtividade.map((p) => (
                <tr key={`${p.equipe_id}-${p.categoria}-${p.unidade}`} data-testid={`prod-linha-${p.equipe_id}-${p.categoria}-${p.unidade}`}>
                  <td data-label="Equipe"><Link to={linkEquipe(p)} style={{ fontWeight: 600, textDecoration: "underline" }} data-testid={`prod-link-${p.equipe_id}-${p.categoria}-${p.unidade}`}>{p.equipe}</Link></td>
                  <td data-label="Atividade">{p.atividade.replace(/ \(.*\)$/, "")} <span style={{ color: "#A1A1AA", fontSize: "0.72rem" }}>({p.categoria})</span></td>
                  <td data-label="Un." className="font-mono" translate="no">{p.unidade}</td>
                  <td data-label="Dias" className="font-mono" style={{ textAlign: "right" }}>{fmtInt(p.dias)}</td>
                  <td data-label="Total" className="font-mono" style={{ textAlign: "right" }}>{fmt(p.total)}</td>
                  <td data-label="Média/dia" className="font-mono font-semibold" style={{ textAlign: "right" }}>{fmt(p.media_diaria)}</td>
                  <td style={{ textAlign: "right" }}><Link to={linkEquipe(p)} aria-label="ver apontamentos"><ArrowSquareOut size={14} weight="bold" /></Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
